// Parking assign tokens are stored normalised (9 chars, no separators) but are
// shown to users grouped in threes (e.g. "3W97SFNNP" -> "3W9-7SF-NNP") to match
// the saisonabo code style on admin and mobile. Display-only — the backend
// normalises dashes/case on input, so the grouped form still resolves.
const formatPin = (code) => {
    if (!code) return code ?? '';
    const clean = String(code).replace(/[^A-Za-z0-9]/g, '').toUpperCase();
    return clean.match(/.{1,3}/g)?.join('-') ?? clean;
};

export default formatPin;
